export const NOTIFICATION_QUERY_PARAM = 'notification'
export const LEARNER_PASSWORD_MIN_CODE_UNIT_LENGTH = 5
export const DEFAULT_PASSWORD_MAX_CODE_UNIT_LENGTH = 32
export const DEFAULT_PASSWORD_MAX_BYTE_LENGTH = 72
